(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('vt', {
        templateUrl: 'views/components/views/vt/vt.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'vtService', 'translateListService', 'p2ReportDefService', 'ttPopoverModel', 'utilityService', 'languageService', function ($stateParams, stateService, translateService, modalService, vtService, translateListService, p2ReportDefService, ttPopoverModel, utilityService, languageService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let vtKeyno = $stateParams.vt_keyno;

            let translations = {
                error: '',
                ok: '',
                done: ''
            };
            
            vm.model = {
                webPageButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.edit.vtlink_p2_webpage_keyno = '' }
                ],
                languageButtons: [
                    { id: 'erase', icon: 'fas fa-eraser', type: 'danger', color: 'danger', onClick: () => { vm.handleFieldChanged('', 'vm.model.edit.destin_language_id'); } },
                    { id: 'select', icon: 'fas fa-list', type: 'primary', color: 'primary', onClick: () => console.log('open popover') }
                ],
                edit: {},
                selectListLanguages: [],
                selectListWebPages: [],
                lockedSave: false
            };

            vm.popoverLanguage = new ttPopoverModel('languageselect')
                .addChecklist({
                    title: 'Languages',
                    required: false,
                    list: [],
                    onChecklistChanged: (list, selectedIds) => vm.model.edit.destin_language_id = createSelectedString(selectedIds)

                })
                .onClose(() => {});

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATE SERVICE

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATE SERVICE

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadEdit() {
                vm.model.edit = (await vtService.getEdit({ vt_keyno: vtKeyno }))[0];
                loadDestinLanguages();
            }

            async function loadLanguages() {
                vm.model.selectListLanguages = await translateListService.listLanguages();
            }

            async function loadWebPages() {
                vm.model.selectListWebPages = await p2ReportDefService.listWebPages();
            }

            function loadDestinLanguages() {
                let idsString = vm.model.edit?.destin_language_id;
                
                if (!idsString || !vm.popoverLanguage?.data?.[0]?.data?.list) return;

                let selectedIds = idsString.split(',').map(id => id.trim()).filter(Boolean);

                vm.popoverLanguage?.data?.[0]?.data?.list.forEach(item => {
                    item.is_selected = selectedIds.includes(item.item_id);
                });
                
            }

            function createSelectedString(list) {
                let selectedString = '';
                list.forEach((id) => selectedString += id + ',')
                return selectedString;
            }

            var loadLanguages = function () {
                languageService.list().then(function (result) {
                    angular.copy(result, vm.model.selectListLanguages);
                    angular.copy(result, vm.popoverLanguage.data[0].data.list);
                });
            };

            function selectIdsInList(list, ids) {
                const seperator = ids.match(/\D/)?.[0] ?? ' ';
                let selectedIds = ids.split(seperator);

                list.forEach((item) => {
                    if (selectedIds.length > 0 && selectedIds.includes(item.item_id)) {
                        console.log('item is selected');
                        item.is_selected = true;
                    } else if (selectedIds.length === 0 && item.item_id === ids) {
                        console.log('item is selected but no list');
                        item.is_selected = true;
                    } else {
                        item.is_selected = false;
                    }
                });

                return list;
            }

            vm.handleFieldChanged = function (value, id) {
                if (id.startsWith('vm.') !== true) return;

                var parts = id.split('.'); 

                switch (parts[parts.length - 1]) {
                    case 'destin_language_id':
                        console.dir('language ids change');
                        if (utilityService.validateWatchValue(value, vm.model.edit.destin_language_id) === true) {

                            vm.model.edit.destin_language_id = value;

                            selectIdsInList(vm.popoverLanguage.data[0].data.list, value);

                            if (utilityService.validateParmsValue(vm.model.edit.destin_language_id, true) !== true) return;
                        }
                        break;
                    
                    default:
                        utilityService.setValueToVariable(vm, parts, value);
             
                }
            };

 
            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

            vm.saveChanges = function () {
                vm.model.lockedSave = true;

                vtService.saveObj(vm.model.edit).then((response) => {
                    if (response[0] && response[0].errorcode !== '0') {
                    	modalService.show({
                    		type: 'warning',
                    		title: translations.error,
                    		message: response[0].errormessage,
                    		buttons: [{
                    			label: translations.ok,
                    			cssClass: 'btn-warning',
                    			action: (dialogItself) => {
                    				dialogItself.close();
                    				vm.model.lockedSave = false;
                    			}
                    		}]
                    	});
                    } else {
                    	vm.model.lockedSave = false;
                    	stateService.back();
                    }
                });
            };

            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

            // #region BUTTON TRANSLATE AND PUBLISH PROCEDURE FUNCTION CALL

            vm.translateAndPublish = async function () {
                vm.model.lockedSave = true;

                vtService.translateAndPublish(vm.model.edit).then((response) => {
                    if (response[0] && response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'danger',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-danger',
                                action: (dialogItself) => {
                                    dialogItself.close();
                                    vm.model.lockedSave = false;
                                }
                            }]
                        });
                        vm.model.lockedSave = false;

                    } else {
                        modalService.show({
                            type: 'success',
                            title: translations.done,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-success',
                                action: (dialogItself) => {
                                    dialogItself.close();
                                    vm.model.lockedSave = false;
                                }
                            }]
                        });
                        vm.model.lockedSave = false;
                        //stateService.back();


                    }
                })
            };

            // #endregion BUTTON TRANSLATE AND PUBLISH PROCEDURE FUNCTION CALL

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                translate();
                loadLanguages();
                loadEdit();
                loadWebPages();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
